import Base from 'src/storage/base';

class PatientsAnalyseIndexModel extends Base {
  id = 'PatientsAnalyseIndexModel';

  defaultState = () => ({
    tab: 'analyses'
  });

  apiConfig = {
    patient_detail: {
      url: 'patient/detail',
      validation: {
        id: 'userId'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile'
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  loadDetail = (id, cb) => {
    this.setState({ patient: null });
    this.api('patient_detail', { id }, (error, patient, success) => {
      if (success) {
        this.setState({ patient });
        this.emit('openPatientAnalyse', patient);
      } else {
        cb();
      }
    });
  };
}
const model = new PatientsAnalyseIndexModel();

export default model;
